import type { AxiosResponse } from 'axios';
import routes from '@/config/routes';
import { v3Get, v3Post } from '@/api/axios.instance.V3';
import type { IPermission } from '@/store/admin/types/types';
import type { ApiResponse } from '../types';

const getPermissionList = (): ApiResponse => v3Get(routes.backendUrl.permissionAdmin.permissionList);
const getPermissionByClientIdList = (clientId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.permissionAdmin.permission}/client/${clientId}/list`);
const getPermissionLevelList = (): ApiResponse => v3Get(routes.backendUrl.permissionAdmin.permissionLevelList);
const savePermission = async (permission: IPermission): Promise<AxiosResponse> => {
  return await v3Post(`${routes.backendUrl.permissionAdmin.permission}/create`, permission);
};
export const permissionAdminApi = {
  getPermissionList,
  getPermissionLevelList,
  getPermissionByClientIdList,
  savePermission,
};
